import React, { useState } from 'react';
import './GroupBySelector.css';

interface GroupBySelectorProps {
  options?: string[];
  defaultValue?: string;
  onChange?: (value: string) => void;
}

const GroupBySelector: React.FC<GroupBySelectorProps> = ({
  options = ['Artist', 'Border'],
  defaultValue = 'Artist',
  onChange,
}) => {
  const [selected, setSelected] = useState(defaultValue);

  const handleClick = (option: string) => {
    setSelected(option);
    onChange?.(option);
  };

  return (
    <div className="group-selector">
      <span className="group-label">Group by:</span>
      <div className="group-buttons">
        {options.map((option) => (
          <button
            key={option}
            className={`group-button ${selected === option ? 'active' : ''}`}
            onClick={() => handleClick(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default GroupBySelector;
